/**
 * How a person is referred to. The GR number is the General Register serial,
 * given only at enrollment — an applicant has none yet and goes by their
 * application number (`AdmissionApplication.applicationNumber`).
 */

/** "GR 000012", or "Applicant" for someone not yet enrolled. */
export const grLabel = (p: { grNumber?: string | null }): string =>
  p.grNumber ? `GR ${p.grNumber}` : 'Applicant';

/** The person's profile page: by GR number, or by id while they have none. */
export const profilePath = (p: { _id: string; grNumber?: string | null }): string =>
  `/app/students/${p.grNumber || p._id}`;

/** The number a payer is known by on finance screens: the GR number once
 *  enrolled, else the application number; '' when neither is known. */
export const payerNumber = (p: { grNumber?: string | null; applicationNumber?: string | null }): string =>
  p.grNumber || p.applicationNumber || '';
